import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMsgSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      d="M7.5 4.382a1.494 1.494 0 0 0-1.7-.209V4H5v5h1V5.5a.5.5 0 0 1 1 0V9h1V5.5a.5.5 0 0 1 1 0V9h1V5.41l-.003-.002A1.5 1.5 0 0 0 7.5 4.382ZM14 7.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H11V8h1.45c.18 0 .317-.037.41-.11a.424.424 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45h-.37c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H14v1h-1.45c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 8.8c-.207.133-.457.2-.75.2h-.55c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38H19v6a1 1 0 0 1-1 1h-2.5v-1H17c.84 0 1 0 1-1v-.2Zm-.65-.8c.22 0 .383-.057.49-.17a.565.565 0 0 0 .16-.38V5h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.6Z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 13h14v11H5V13Zm1.707 1L12 19.293 17.293 14H6.707ZM18 14.707 14.207 18.5 18 22.293v-7.586ZM17.293 23 13.5 19.207l-1.5 1.5-1.5-1.5L6.707 23h10.586ZM6 22.293v-7.586L9.793 18.5 6 22.293Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconMsgSizeS;
